module.exports = __webpack_public_path__ + "img/share-node.6de0117f.svg";